import styles from './step-dialog.module.scss';
import { Icon } from '@mui/material';
import { GrayOutlinedButton, PrimaryButton, SecondaryButton } from '../button/button';
import Dialog, { DialogActions, DialogContent, DialogTitle } from '../dialog/dialog';
import Divider from '../divider/divider';
import Stepper, { Step, StepLabel } from '../stepper/stepper';
import { t } from 'i18next';

/* eslint-disable-next-line */
export interface StepDialogProps {
  onClose: () => void;
  children: React.ReactNode;
  steps: string[];
  activeStep: number;
  setActiveStep: (step: number) => void;
  onFinish: () => void;
  title: string
}

export function StepDialog(props: StepDialogProps) {
  const handleNext = () => {
    if (props.activeStep === props.steps.length - 1) {
      props.onFinish();
    } else {
      props.setActiveStep(props.activeStep + 1);
    }
  };
  const handleBack = () => props.setActiveStep(props.activeStep - 1);
  return (
    <Dialog open={true} maxWidth={"xl"} fullWidth>
      <DialogTitle>{props.title}</DialogTitle>
      <DialogContent>
        <Stepper activeStep={props.activeStep} className='mb-5'>
          {props.steps.map((label, index) => {
            const stepProps = {};
            const labelProps = {};
            return (
              <Step key={label} {...stepProps}>
                <StepLabel {...labelProps}>{label}</StepLabel>
              </Step>
            );
          })}
        </Stepper>
        {props.children}
      </DialogContent>
      <DialogActions>
        <div className="d-flex flex-wrap">
          <SecondaryButton
            disabled={props.activeStep === 0}
            onClick={handleBack}
            size='large'
            variant='outlined'
            className='minButtonWidth'
            startIcon={<Icon>arrow_back</Icon>}>
            {t("standard.back")}
          </SecondaryButton>
          <Divider orientation="vertical" variant="middle" flexItem className='mx-4' />
          <GrayOutlinedButton size='large' className='minButtonWidth me-3' onClick={props.onClose}>
            {t("standard.cancel")}
          </GrayOutlinedButton>
          <PrimaryButton size='large' variant='contained' className='minButtonWidth mt-3 mt-sm-0' onClick={handleNext}>
            {props.activeStep === props.steps.length - 1 ? t("standard.complete") : t("standard.next")}
          </PrimaryButton>
        </div>
      </DialogActions>
    </Dialog>
  );
}

export default StepDialog;